import React from 'react';

/**
 * FlagIcon — wrapper do flag-icons (npm: flag-icons).
 *
 * Props:
 *   - code: string ISO 3166 alpha-2 minúsculo (ex.: "us", "br"). Use "xx" pra
 *     ativar o fallback (globo 🌐).
 *   - size: largura/altura ('14px' padrão).
 *   - title: tooltip nativo.
 *   - rounded: quando true, renderiza CIRCULAR (estilo ElevenLabs/social).
 *     A bandeira é cropada por overflow:hidden + borderRadius:50% num wrapper
 *     quadrado. Quando false (default), mantém aspect-ratio 4:3 retangular.
 *   - style: override opcional.
 */
export default function FlagIcon({ code, size = '14px', title, rounded = false, style }) {
  const safeCode = (code || '').trim().toLowerCase();
  const isFallback = !safeCode || safeCode === 'xx';

  if (isFallback) {
    return (
      <span
        title={title}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: size,
          height: size,
          fontSize: size,
          lineHeight: 1,
          ...style,
        }}
        aria-label={title || 'Idioma'}
      >
        🌐
      </span>
    );
  }

  // Modo redondo: wrapper quadrado com overflow hidden + bandeira cover por dentro.
  if (rounded) {
    return (
      <span
        title={title}
        aria-label={title || safeCode.toUpperCase()}
        style={{
          display: 'inline-block',
          width: size,
          height: size,
          borderRadius: '50%',
          overflow: 'hidden',
          verticalAlign: 'middle',
          flexShrink: 0,
          boxShadow: '0 0 0 1px rgba(0,0,0,0.10)',
          ...style,
        }}
      >
        <span
          className={`fi fi-${safeCode}`}
          style={{
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
          }}
        />
      </span>
    );
  }

  // Modo retangular (padrão histórico): flag-icons aplica aspect-ratio 4:3 auto.
  return (
    <span
      className={`fi fi-${safeCode}`}
      title={title}
      aria-label={title || safeCode.toUpperCase()}
      style={{
        display: 'inline-block',
        width: size,
        verticalAlign: 'middle',
        borderRadius: '2px',
        boxShadow: '0 0 0 1px rgba(0,0,0,0.08)',
        ...style,
      }}
    />
  );
}
